module.exports = __webpack_public_path__ + "media/images/tizymap-0604dc796823a06cb67c2b06f434bd84.svg";